import React from "react";
import "./LandingPage.css";

const LandingPage = () => {
const services = [
  "הובלות מיוחדות",
  "הובלת ציוד כבד",
  "הובלת מכולות / קונטיינרים",
  "הובלת מבנים / קרוואנים / מיגוניות",
  "השכרת מנוף",
  "מנוף סל להשכרה",
  "מנוף זרוע להשכרה",
  "מנוף סל להרמת אדם",
  "השכרת סל הרמה",
  "הרמת זכוכית וציוד כבד",
];

  return (
    <div className="landing-container" dir="rtl">

      {/* רקע */}
      <div className="background-overlay"></div>

      {/* תוכן */}
      <div className="content-wrapper">

        <div className="brand-badge">
          נצר הובלות ומנופים בע״מ
        </div>

        <h1 className="main-heading">
          הובלות ומנופים
          <span className="heading-highlight">
            ברמה אחרת
          </span>
        </h1>

        <h2 className="secondary-heading">
          פתרונות הובלה, הרמה ושינוע
          <br />
          ללקוחות פרטיים ועסקיים
        </h2>

        <p className="description-paragraph">
          נצר הובלות ומנופים בע״מ מספקת שירותי הובלה,
          מנופים, הרמות ושינוע תוך הקפדה על מקצועיות,
          בטיחות, אמינות ושירות אישי לכל לקוח.
        </p>

        <p className="description-sub">
          הצוות שלנו מעניק מגוון פתרונות הובלה ושינוע:
        </p>


        {/* שירותים */}

        <ul className="services-list-centered">

          {services.map((service, index) => (

            <li
              key={index}
              className="service-bullet-item"
            >

              <span className="bullet-point">
                ✓
              </span>

              <span className="bullet-text">
                {service}
              </span>

            </li>

          ))}

        </ul>


        {/* הבטחה */}

        <p className="promise-text">
          אנו מתחייבים להעניק לכל לקוח שירות מקצועי,
          אדיב ואמין, עם התאמה מלאה לצרכים ולתנאי השטח.
        </p>


        {/* CTA */}

        <div className="call-to-action-section">

          <p className="cta-highlight">
            צריכים הובלה או מנוף?
          </p>

          <p className="cta-highlight">
            אנחנו כאן כדי לבצע את העבודה בצורה בטוחה ומקצועית.
          </p>

          <a
            href="tel:0506615262"
            className="cta-button"
          >
            התקשרו עכשיו
          </a>

        </div>

      </div>
    </div>
  );
};

export default LandingPage;